import React from 'react';

const SvgPen = props => (
  <svg width={15} height={15} {...props}>
    <path
      d="M13.727.674a2.301 2.301 0 0 0-3.254 0L1.35 9.796a.511.511 0 0 0-.132.225l-1.2 4.331a.511.511 0 0 0 .63.63l4.331-1.2a.511.511 0 0 0 .225-.132l9.123-9.122c.897-.9.897-2.355 0-3.254l-.6-.6zM2.464 10.129L9.93 2.662l2.408 2.408-7.466 7.466-2.408-2.407zm-.481.965l1.924 1.923-2.661.738.737-2.661zm11.62-7.289l-.541.542-2.409-2.408.543-.542c.5-.5 1.309-.5 1.808 0l.6.6a1.28 1.28 0 0 1 0 1.808z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgPen;
